import * as React from 'react';

const InviteOnlyGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h144v144H0z" />
            <path fill="#F8FAFF" fillRule="nonzero" d="M24 112h96V60H24z" />
            <path
                fill="#F6682F"
                fillRule="nonzero"
                d="M72 86l-48 26V60l48 26zm-48 26h96V60l-96 52z"
            />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M104.515 60H120v52H24V60h15.483"
            />
            <path
                fill="#F8FAFF"
                fillRule="nonzero"
                d="M105 68.342L72.501 85 40 68.342V32h52.62L105 44.113z"
            />
            <path stroke="#363A43" strokeWidth={3} d="M120 60l-96 52" />
            <path fill="#D2D6DF" fillRule="nonzero" d="M47 49h37V32H47z" />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M24 60l48 26m32-42H92V32"
            />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M105 69V44.333L92.62 32H40v37m7-15h49m-49 6h49m-49 6h49m-49 6h49m-38 6h28"
            />
            <path
                stroke="#363A43"
                strokeWidth={2.573}
                d="M51 38h3m3 0h3m3 0h3"
            />
        </g>
    </svg>
);

InviteOnlyGraphicSvg.displayName = 'InviteOnlyGraphicSvg';
export default InviteOnlyGraphicSvg;
